<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">运营</a></el-breadcrumb-item>
          <el-breadcrumb-item>商家设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="form" label-width="160px">
        <el-form-item label="商家名称">
          <el-col :span="12">
            <el-input v-model="form.name" ></el-input>
          </el-col>
        </el-form-item> 
        <el-form-item label="积分支付上限比例">
          <el-col :span="12">
            <el-input v-model="form.pointPayLimit">
              <el-button slot="append">%</el-button>
            </el-input>   
          </el-col>
        </el-form-item>   
        <el-form-item label="联系人">
          <el-col :span="12">
            <el-input v-model="form.linkMan"></el-input>
          </el-col>       
        </el-form-item>
        <el-form-item label="联系电话">
          <el-col :span="12">
            <el-input v-model="form.mobile" ></el-input>
          </el-col>       
        </el-form-item>
        <el-form-item label="客服账号">
          <el-col :span="12">
            <el-input v-model="form.customerService"></el-input>
          </el-col>       
        </el-form-item>        
        <el-form-item label="备注">
          <el-col :span="12">
            <el-input type="textarea" v-model="form.memo"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item >
          <el-col :span="12">
            <el-button type="primary" @click="SaveBusiness">保 存</el-button>
            <el-button style="margin-left: 8px" @click="handleBack">返回列表</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>    
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  export default {
    props:{
    },
    data (){
      return {
        form:{},
      }
    },
    computed:{     
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/Merchant/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.form = resp.data.merchants
      })
    },
    methods:{     
      SaveBusiness:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Merchant/Save',         
          data:that.form
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },      
      handleBack(){
        var that = this
        this.$confirm('请先确定已经保存内容！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$router.push({
            name: 'merchant',
            params: {
              queryParam: that.$route.params.queryParam
            }
          })
        }).catch(() => {
            
        });
      }
    },
    components:{
      
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
</style>